import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-reject-review.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessRejectReview';

class AgentBookingMailInprocessRejectReviewCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessRejectReview implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessRejectReviewCtrl];
}

export default MODULE_NAME;
